export enum ModalWindowType {
  Message,
  Confirmation,
  Selection,
  ButtonSelection,
  Checklist,
  Qrcode,
  LowBalance,
  TopUpBalance
}
